// The chat console's offer to open chats for the Reviews lens: a Triage
// row's "Investigate in chat", and a case Investigate opens as a chat. The
// console registers a host while it is mounted; the lens offers those doors
// only while one is there.
//
// A host (lib/triageChatHost.js) is { stage, ask?, offer, open, has, optionsFor }:
//   stage({ title, notes, agentOptions, context, starters, startersPending, input }) -> { chatId, serverChatId, ready }
//     creates the chat opened on what the person chose: the notes as system
//     lines, `agentOptions` folded into its agent, `context.text` sent ahead
//     of their first prompt, once, `starters` offered as questions a click
//     puts in the composer (or marked pending while they are written), and
//     `input` already in it. Brings it on screen; nothing runs until they
//     ask. `ready` settles with the agent.
//   ask({ title, notes, agentOptions, context, prompt }) -> { chatId, serverChatId, ready, sent }
//     stage() and then send `prompt` as the chat's first question once its
//     agent is built, so the chat is already working when it comes on screen.
//     Absent on a console that cannot send for another surface.
//   offer({ chatId, serverChatId }, starters) -> boolean   fills a staged
//     chat's starters when they arrive; a chat already asked takes nothing.
//   open({ chatId, serverChatId }) -> boolean   activates that chat on screen.
//   has({ chatId, serverChatId }) -> boolean    whether the console still holds it.
//   say({ chatId, serverChatId }, prompt) -> boolean   brings the chat on
//     screen and sends `prompt` as the person's message (taken mid-run when
//     the chat is at work). Absent on a console that cannot send for another
//     surface.
//   notify({ chatId, serverChatId }, { text, label }) -> Promise<boolean>
//     once the chat is free, runs a turn on `text` as a notification, shown
//     as the system line `label`; false when the chat is gone or stayed busy.
//     Absent on a console that cannot run a turn for another surface.
let host = null;
const subscribers = new Set();

function notify() {
    subscribers.forEach((fn) => fn());
}

export function registerTriageChatHost(next) {
    if (!next || typeof next.stage !== "function") throw new Error("A triage chat host needs a stage function.");
    host = next;
    notify();
    return () => {
        if (host !== next) return;
        host = null;
        notify();
    };
}

export function getTriageChatHost() {
    return host;
}

export function triageChatHostAvailable() {
    return host != null;
}

export function subscribeTriageChatHost(fn) {
    subscribers.add(fn);
    return () => subscribers.delete(fn);
}

export function resetTriageChatHostForTests() {
    host = null;
    subscribers.clear();
}
